import { render, staticRenderFns } from "./registerInfo.vue?vue&type=template&id=3f40e9b0"
import script from "./registerInfo.vue?vue&type=script&lang=js"
export * from "./registerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports